import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  fetchRoomDetails as fetchRoomDetailsAction,
  fetchRoomTypes as fetchRoomTypesAction,
  fetchAvailableRooms as fetchAvailableRoomsAction,
  fetchAvailableRoomsForBookingExtension as fetchAvailableRoomsForBookingExtensionAction,
  fetchRoomOptions as fetchRoomOptionsAction,
  fetchArchivedRoomOptions as fetchArchivedRoomOptionsAction,
  fetchFloors as fetchFloorsAction,
  fetchAllRooms as fetchAllRoomsAction,
  createRoom as createRoomAction,
  archiveRoom as archiveRoomAction,
  undoArchiveRoom as undoArchiveRoomAction,
  fetchRoomsAvailability as fetchRoomsAvailabilityAction,
  fetchRoomTypeFilters as fetchRoomTypeFiltersAction,
  fetchRoomNeighbours as fetchRoomNeighboursAction
} from './';

import {
  fetchRoomTypes,
  fetchAvailableRooms,
  fetchAvailableRoomsForBookingExtension,
  fetchRoomOptions,
  fetchArchivedRoomOptions,
  fetchFloors,
  fetchAllRooms,
  createRoom,
  archiveRoom,
  undoArchiveRoom,
  fetchRoomDetails,
  fetchRoomsAvailability,
  fetchRoomTypeFilters,
  fetchRoomNeighbours
} from 'sdk/rooms';

function* roomsSaga() {
  yield all([
    createFetchSagaLatest(fetchRoomTypesAction, fetchRoomTypes),
    createFetchSagaLatest(fetchAvailableRoomsAction, fetchAvailableRooms),
    createFetchSagaLatest(fetchRoomOptionsAction, fetchRoomOptions),
    createFetchSagaLatest(
      fetchArchivedRoomOptionsAction,
      fetchArchivedRoomOptions
    ),
    createFetchSagaLatest(
      fetchAvailableRoomsForBookingExtensionAction,
      fetchAvailableRoomsForBookingExtension
    ),
    createFetchSagaLatest(fetchFloorsAction, fetchFloors),
    createFetchSagaLatest(fetchAllRoomsAction, fetchAllRooms),
    createFetchSagaLatest(fetchRoomDetailsAction, fetchRoomDetails),
    createPostSagaLatest(createRoomAction, createRoom),
    createPostSagaLatest(archiveRoomAction, archiveRoom),
    createPostSagaLatest(undoArchiveRoomAction, undoArchiveRoom),
    createFetchSagaLatest(fetchRoomsAvailabilityAction, fetchRoomsAvailability),
    createFetchSagaLatest(fetchRoomTypeFiltersAction, fetchRoomTypeFilters),
    createFetchSagaLatest(fetchRoomNeighboursAction, fetchRoomNeighbours)
  ]);
}

export default roomsSaga;
